<template>
  <div class="page-outer">
    <div class="preview-wrap" v-loading="loading">
      <div class="count-area">
        <el-tabs v-model="activeGroup" type="card" class="group-tabs">
          <el-tab-pane
            v-for="groupItem of dataList"
            :key="groupItem.id"
            :label="groupItem.campaignName"
            :name="String(groupItem.id)"
          >
            <div class="group-area">
              <div class="group-item" v-if="!alreadyCampaignId">
                <span class="group-item-title">广告系列状态：</span>
                <el-switch
                  class=""
                  @change="changeGroupStatus(groupItem)"
                  v-model="groupItem.isOpen"
                >
                </el-switch>
              </div>
              <div class="group-item">
                <span class="group-item-title">推广目标：</span>
                <span class="group-item-value">{{ groupItem.advertisingChannelSubType }}</span>
              </div>
              <div class="group-item">
                <span class="group-item-title">日预算：</span>
                <span class="group-item-value">{{ groupItem.dailyBudget }} USD</span>
              </div>
              <div class="group-item" v-if="groupItem.price">
                <span class="group-item-title">出价：</span>
                <span class="group-item-value">{{ groupItem.price }}</span>
              </div>
              <div class="group-item" v-else>
                <span class="group-item-title">tROAS：</span>
                <span class="group-item-value">{{ groupItem.troas }}</span>
              </div>
              <div class="group-item" style="display: flex">
                <div class="group-item-title">地区：</div>
                <div class="group-item-value">
                  <div class="group-item-value">
                    <span style="font-weight: 600">定向：</span>{{ groupItem.include }}
                  </div>
                  <div class="group-item-value">
                    <span style="font-weight: 600">排除：</span>{{ groupItem.exclude }}
                  </div>
                </div>
              </div>
              <div class="group-item">
                <span class="group-item-title">语言：</span>
                <span class="group-item-value">{{ groupItem.languages }}</span>
              </div>
              <div class="btn-list">
                <el-button
                  type="primary"
                  @click="changeAdStatus(selectCampaign[groupItem.id], false)"
                  :disabled="
                    !selectCampaign[groupItem.id] || selectCampaign[groupItem.id].length === 0
                  "
                  >批量暂停</el-button
                >
                <el-button
                  type="primary"
                  @click="changeAdStatus(selectCampaign[groupItem.id], true)"
                  :disabled="
                    !selectCampaign[groupItem.id] || selectCampaign[groupItem.id].length === 0
                  "
                  >批量开启</el-button
                >
              </div>
              <div class="table-wrap">
                <el-table
                  ref="table"
                  :data="groupItem.adGroups"
                  style="width: 100%"
                  :max-height="tableHeight"
                  @selection-change="handleSelectionChange($event, groupItem)"
                >
                  <el-table-column type="selection" width="100px"> </el-table-column>
                  <el-table-column label="状态" width="200px">
                    <template slot-scope="scope">
                      <el-switch
                        @change="changeAdStatus([scope.row], scope.row.isOpen, false)"
                        v-model="scope.row.isOpen"
                      >
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="广告组名称" prop="adGroupName"> </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="bottom-btnlist">
      <el-button class="bot-btn" @click="goBack">返回</el-button>
      <el-button class="bot-btn primary" :loading="pushLoading" @click="pushAdvertise"
        >发布广告</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getGooglePreviewList, publishGoogle, updateAdStatus } from "@/api/promotion-google.js";
export default {
  components: {},
  data() {
    return {
      activeGroup: null,
      dataList: [],
      selectCampaign: {},
      pushLoading: false,
      loading: false,
      templateId: null, //当前预览的id
      tableHeight: window.innerHeight - 245,
    };
  },
  activated() {
    this.initData();
    this.activeGroup = "";
  },
  methods: {
    handleSelectionChange(val, data) {
      this.$set(this.selectCampaign, data.id, val);
    },
    changeAdStatus(list, flag, isBatch = true) {
      updateAdStatus({ ids: list.map((item) => item.id), isOpen: flag }).then((res) => {
        if (res.code === "0000") {
          this.selectCampaign = [];
          if (isBatch) {
            this.initData();
          }
          this.$message.success("操作成功");
        }
      });
    },
    changeGroupStatus(data) {
      updateAdStatus({ ids: [data.id], isOpen: data.isOpen }).then((res) => {
        if (res.code === "0000") {
          this.$message.success("操作成功");
        }
      });
    },
    initData() {
      this.loading = true;
      this.templateId = this.$route.query.templateId;
      getGooglePreviewList({
        previewId: this.$route.query.templateId,
      })
        .then((res) => {
          this.dataList = res.data;
          this.activeGroup =
            this.activeGroup && Number(this.activeGroup) > 0
              ? this.activeGroup
              : String(this.dataList[0].id);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    pushAdvertise() {
      this.pushLoading = true;
      publishGoogle({
        groupId: this.dataList[0]?.groupId,
      }).then((res) => {
        this.pushLoading = false;
        if (res.code === "0000") {
          this.$confirm("提交成功，可在任务中心 查看进度", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "查看进度",
            type: "success",
          })
            .then(() => {
              this.$router.push({
                path: "/promotion.html",
                query: {
                  key: "GoogleReport",
                },
              });
            })
            .catch(() => {
              this.$router.replace({
                name: "proTable",
                query: {
                  key: "TaskCenter",
                },
              });
            });
        }
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
      advertiserName: (state) => state.PromotionTtV2.baseData.advertiserName,
    }),
  },
};
</script>

<style lang="less" scoped>
.page-outer {
  .preview-wrap {
    margin: 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    min-height: 400px;
    .top-tabs {
      /deep/ .el-tabs__nav {
        margin-left: 24px;
      }
    }
    .group-tabs {
      /deep/ .el-tabs__nav {
        margin-left: 0px;
      }
      /deep/ .el-tabs__header {
        margin: 0px;
      }
      /deep/ .el-tabs__item {
        background-color: rgba(0, 0, 0, 0.02);
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        &.is-active {
          background-color: #fff;
          color: rgba(24, 144, 255, 1);
          font-weight: bold;
        }
      }
    }
    .count-area {
      padding: 24px;
    }
    .group-area {
      min-height: 400px;
      margin-bottom: 24px;
      border-right: 1px solid #e4e7ed;
      border-bottom: 1px solid #e4e7ed;
      border-left: 1px solid #e4e7ed;
      .group-item {
        margin: 12px 24px;
        font-size: 15px;
        &-title {
          width: 110px;
          display: inline-block;
          text-align: right;
          margin-right: 12px;
        }
        &-value {
          font-weight: 500;
        }
      }
      .budget {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        padding: 20px;
      }
      .btn-list {
        padding-left: 20px;
        .btn {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
          border-radius: 2px;
          border: 1px solid rgba(24, 144, 255, 1);
          background: rgba(255, 255, 255, 1);
          .btn-icon {
            margin-right: 4px;
          }
        }
      }
      .table-wrap {
        margin-top: 16px;
        /deep/ td {
          vertical-align: top;
        }
        .cell-wrap {
          .cell-label {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-weight: bold;
            font-size: 14px;
            // margin-top: 6px;
          }
          .cell-value {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }
          .table-cascader {
            line-height: 0px !important;
            /deep/ input {
              border: none;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              background-color: transparent;
              padding: 0px;
              height: 15px;
            }
            /deep/ .el-input {
              line-height: 15px !important;
            }
            /deep/ .el-input__suffix {
              display: none;
            }
          }
        }
      }
    }
  }
  .bottom-btnlist {
    height: 100px;
    padding-left: 16px;
    .bot-btn {
      height: 40px;
      width: 117px;
      color: rgba(24, 144, 255, 1);
      font-size: 14px;
      border-radius: 2px;
      border: 1px solid rgba(24, 144, 255, 1);
      &.primary {
        color: #fff;
        background: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>
